import { useState, useEffect } from 'react';

export default function useIsTablet() {
  const [isTablet, setIsTablet] = useState(window.matchMedia('(max-width: 1020px)').matches);

  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 1020px)');
    const handleResize = () => setIsTablet(mediaQuery.matches);

    mediaQuery.addEventListener('change', handleResize);

    // Cleanup function
    return () => mediaQuery.removeEventListener('change', handleResize);
  }, []);

  return { isTablet };
}
